// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationPermissionsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck,
  CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Path,
} from '@zg-rentals/ts-capps-client';

import type { ListingAlias } from '@zg-rentals/ts-capps-client';

interface PermissionCheckParams {
  listingAlias: ListingAlias;
}

export type CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, PermissionCheckParams]
>;

const CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_GetKey = (getParams: PermissionCheckParams) =>
  [CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Path, getParams] as const;

export const CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_queryOptions = (
  getParams: PermissionCheckParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationPermissionsWebApiHandler_permissionCheck = (
  getParams: PermissionCheckParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationPermissionsWebApiHandler_permissionCheck.getKey =
  CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_GetKey;
